import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { DesktopComponent } from "./components/DesktopComponent";
import "./styles/index.scss";
import { ProjectIntroComponent } from "./webar-core/framework/ProjectIntroComponent";
import { mobileCheck } from "./webar-core/framework/utils/mobileCheck";
import { detectCountry } from "./translation";
import { OrientationWarningComponent } from "./components/OrientationWarningComponent";
import AudioLoadingComponent from "./components/AudioLoadingComponent";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

detectCountry().then((data: any) => {
  let enableChineseTranslation = false;

  if (data.country.toLowerCase() === "cn") {
    enableChineseTranslation = true;
  }

  root.render(
    <>
      {mobileCheck() && (
        <>
          <ProjectIntroComponent translate={enableChineseTranslation}>
            <AudioLoadingComponent translate={enableChineseTranslation} />
            <App translate={enableChineseTranslation} />
          </ProjectIntroComponent>
          <OrientationWarningComponent />
        </>
      )}

      {!mobileCheck() && <DesktopComponent></DesktopComponent>}
    </>
  );
});
